import { useEffect, useState } from "react";
import createSocketConnection from "../../socket/socket";
import { useParams } from "react-router-dom";

const BoundAdjustment = () => {
  const [isConnected, setIsConnected] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const socket = createSocketConnection(id);
    socket.on("connect", () => {
      console.log("socket connected");
      setIsConnected(true);
    });

    // Sample Connection
    socket.on(`${id}_DOCK_DETAILS_SIMPLE`, (data: any) => {
      console.log(data);
    });

    // Disconnection
    socket.on("disconnect", () => {
      setIsConnected(false);
    });

    // Turning off socket
    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.disconnect();
    };
  }, []);
  return <p>{isConnected + ""}</p>;
};

export default BoundAdjustment;
